import React, { useState } from "react";
import $ from 'jquery';
import CancelReservationPopUp from "./cancelReservationPopup";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { formatTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import { contScrollToBottom, contScrollToTop, hideScrolltoBottomHandler, hideScrolltoTopHandler } from "../../JS/scroll";

const MyResReservation = (props) => {

	const { t } = props

	const [showCancelAll, setShowCancelAll] = useState(0);
	const [showContainer, setShowContainer] = useState(false)
	const [confirmCancel, setConfirmCancel] = useState(false)
	const [hideBottomArrow, setHideBottomArrow] = useState(false);
	const [showScrollToTop, setShowScrollToTop] = useState(false);
	const [cancelReservationId, setCancelReservationId] = useState([])
	const [customerReservationData, setCustomerReservationData] = useState(props.customerReservationData || [])

	const displayStatusName = (id) => {
		const status = props.displayStatusName.find((status) => status.id === id);
  		return status ? status.description : false;
	}

	const cancelAllReservations = (event) => {
		event.preventDefault();
		let resId = []
		customerReservationData.forEach((myRes) => {
			if (myRes.status == 1) {
				resId.push(myRes.id)
			}
		})
		setCancelReservationId(resId);
		setConfirmCancel(true);
	}

	const handleScroll = () => {
        hideScrolltoBottomHandler('my-order', (bool) => setHideBottomArrow(bool))
        hideScrolltoTopHandler("my-order",(bool) => setShowScrollToTop(bool))
    }

	const formatCustomerReservationData = () => {
		const { selectedResortId, data } = props;
		const newData = [];

		customerReservationData.forEach((myRes) => {
			const resortData = data.find((resort) => resort.id == myRes.resortId);

			if (myRes.status == 1) {
				setShowCancelAll((prevValue) => prevValue + 1)
			}

			if (selectedResortId) {
				if (myRes.resortId == selectedResortId) {
					if (resortData) {
						const restaurantData = resortData.restaurantsList.find(
							(restaurant) => restaurant.id == myRes.restaurantId
						);

						if (restaurantData) {
							const updatedData = {
								...myRes,
								restaurantDetails: restaurantData,
							};
							newData.push(updatedData);
						}
					}
				}

			} else {
				if (resortData) {
					const restaurantData = resortData.restaurantsList.find(
						(restaurant) => restaurant.id == myRes.restaurantId
					);

					if (restaurantData) {
						const updatedData = {
							...myRes,
							restaurantDetails: restaurantData,
							resortImage: resortData.image || null,
						};
						newData.push(updatedData);
					}
				}
			}
		});


		setCustomerReservationData(newData);
	};

	React.useEffect(() => {

		if(showContainer){
			$("body").addClass("overlay-cast");
		} else {
			$("body").removeClass("overlay-cast");
		}

	},[showContainer])


	React.useEffect(() => {
		formatCustomerReservationData();
	}, [props.selectedResortId])


	return customerReservationData.length > 0 && (
		<>
			<section className={`my-orders ${showContainer ? "overlay" : null}`}>
				<div class="orders-container">
					<div class="orders-heading">
						<h5>{customerReservationData.length > 1 ? t('resReservation.myReservations') : t('resReservation.myReservation')}</h5>
						<a onClick={() => setShowContainer(!showContainer)} class="order-toggle">{showContainer ? <i class="fas fa-lg fa-chevron-down"></i> : <i class="fas fa-lg fa-chevron-up"></i>}</a>
					</div>
					{showContainer && <form>
						<div class="orders-body-container">
							<div class={`orders-body-scroller ${showCancelAll > 1 ? null : "no-buttons"}`} style={customerReservationData.length > 4 ? {} : { display: "none" }}>
                                {showScrollToTop && <div onClick = {() => contScrollToTop ("my-order")} class="orders-scroll scroll-up"><i class="fa fas fa-chevron-up"></i></div>}
                                {!hideBottomArrow && <div onClick = {() => contScrollToBottom("my-order")} class="orders-scroll scroll-down"><i class="fa fas fa-chevron-down"></i></div>}
                            </div>
							<div id="my-order" onScroll={handleScroll} class="orders-body">
							{[...customerReservationData].reverse().map((resData) => {
								return (
										<div class="row order-row multi-btn">
											<div class="col col-3 order-preview">
												{props.selectedResortId ? resData.restaurantDetails.image ? resData.restaurantDetails.image :
													<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.16 69.16" style={{ fill: "#010101" }}><defs></defs>
														<g id="Layer_1-2" data-name="Layer 1">
															<path class="cls-1" d="M37.44,35.84L4.14,69.16,.07,65.09,33.36,31.76l-2.03-2.04c-3.37-3.38-3.37-8.85,0-12.23L48.8,0l4.07,4.07-17.48,17.5c-1.13,1.12-1.13,2.95,0,4.08,0,0,0,0,0,0l2.04,2.04L56.95,8.15l4.07,4.08-19.52,19.54,2.03,2.04c1.13,1.13,2.95,1.13,4.07,0l17.49-17.5,4.06,4.08-17.48,17.5c-3.38,3.37-8.84,3.37-12.22,0l-2.03-2.04Zm-19.76,3.48l7.75-7.76c-2.8-4.21-3.16-9.58-.95-14.12L9.59,1.71c-2.19-2.19-5.75-2.19-7.94,0C.59,2.76,0,4.19,0,5.68c-.02,5.32,1.3,10.56,3.84,15.24,3.53,6.87,8.21,13.09,13.83,18.39Zm27.9,6.86c-2.82,0-5.58-.82-7.94-2.39l-4.9,4.9c4.89,2.2,10.25,3.17,15.61,2.8l16.56,17.61,4.2-3.95-18.83-19.82c-1.51,.54-3.1,.83-4.7,.85Z" />
														</g>
													</svg>
													: resData.resortImage ? resData.resortImage :
														<svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84.97 51.05" style={{ fill: "#010101" }}><defs></defs>
															<g id="Layer_1-2" data-name="Layer 1">
																<path class="cls-1" d="m45.02,51.05c-14.13-.02-25.58-11.47-25.6-25.6,1.34-33.94,49.86-33.92,51.2,0-.02,14.13-11.47,25.58-25.6,25.6Zm0-46.93c-11.78.01-21.32,9.56-21.33,21.33,1.12,28.28,41.55,28.27,42.67,0-.01-11.78-9.56-21.32-21.33-21.33Zm17.07,21.33c0-1.18-.96-2.13-2.13-2.13s-2.13.96-2.13,2.13c-.54,16.92-25.06,16.91-25.6,0,0-7.07,5.73-12.79,12.8-12.8,1.18,0,2.13-.96,2.13-2.13s-.96-2.13-2.13-2.13c-9.42.01-17.06,7.65-17.07,17.07.8,22.59,33.34,22.58,34.13,0Z" />
																<path class="cls-1" d="m15.24,5.21c-.94,0-1.69.76-1.69,1.69v10.16c0,2.14-1.36,4.05-3.39,4.77V6.9c0-.94-.76-1.69-1.69-1.69s-1.69.76-1.69,1.69v14.93c-2.02-.71-3.38-2.62-3.39-4.77V6.9c0-.94-.76-1.69-1.69-1.69s-1.69.76-1.69,1.69v10.16c0,4.02,2.83,7.49,6.77,8.3v18.79c0,.94.76,1.69,1.69,1.69s1.69-.76,1.69-1.69v-18.79c3.94-.81,6.77-4.27,6.77-8.3V6.9c0-.94-.76-1.69-1.69-1.69Z" />
																<path class="cls-1" d="m84.96,22.09c-.15,6.52-3.27,12.61-8.47,16.55v5.46c0,.94-.76,1.69-1.69,1.69s-1.69-.76-1.69-1.69V8.55c-.03-1.3.72-2.49,1.91-3.02,1.37-.56,2.93-.25,3.99.78,3.93,4.31,6.05,9.96,5.95,15.79Z" />
															</g>
														</svg>
												}
											</div>
											<div class="col col-3 order-details">
												<p class="item-name">{resData.restaurantDetails.description}</p>
												<p class="item-desc">{dateFormatHandler(resData.dateTime, props.dateFormat) + ", " + formatTime(resData.dateTime, toBool(props.timeFormat), props.gmtOffset)}</p>
											</div>
											{resData.status == 1 ?
												<div class="col col-3 order-add-remove">
													<a onClick={() => { $("body").removeClass("overlay-cast"); props.editReservation(resData)}} class="close"><i class="fas fa-pen"></i></a>
													<a onClick={() => { setCancelReservationId([resData.id]); setConfirmCancel(true) }} class="close"><i class="fas fa-times"></i></a>
												</div>
												:
												<div class="col col-3 order-add-remove">
													<div class="active-status">
														{resData.status == -3 && displayStatusName(resData.status) && <span class="fa fa-trash"></span>}
														{resData.status == -1 && displayStatusName(resData.status) && <span class="fa fa-times-circle"></span>}
														<span> </span>
														{displayStatusName(resData.status) || "Status fetch error"}
													</div>
												</div>
											}
										</div>
								)
							})}
							</div>
							{showCancelAll > 1 &&
								<div class="controls">
									<input onClick={(event) => cancelAllReservations(event)} type="submit" name="place order" value={t('resReservation.cancel_all')} />
								</div>}
						</div>
					</form>}
				</div>
			</section>
			{confirmCancel && <CancelReservationPopUp cancelReservationId={cancelReservationId} handleDeleteReservation={(bool) => { setShowContainer(false); setConfirmCancel(false); props.handleDelete(bool)}} close={() => { setCancelReservationId([]); setConfirmCancel(false) }} />}
		</>
	)
}

const mapStateToProps = state => {
	return {
		installedAppVersion: state.store.installedAppVersion,
		installedAppBuildNo: state.store.installedAppBuildNo,
		gmtOffset: state.store.home.serverTimeDate.gmtOffset,
		timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
		dateFormat: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
	}
}

export default connect(mapStateToProps, { closeOrderPopUp })(withTranslation('translations')(MyResReservation));